<template>
  <v-layout align-center fill-height justify-space-between row wrap>
    <v-flex
      xs12
      sm12
      md4
      v-if="
        task.approvalHeader &&
          task.approvalHeader.defaultValue &&
          task.approvalHeader.defaultValue.dimensionList &&
          task.approvalHeader.defaultValue.dimensionList.length > 0
      "
    >
      <v-layout column>
        <v-flex>
          <div
            style="font-size: 1.0em;"
            align="left"
            v-if="task.approvalHeader.defaultValue.dimensionList.length > 0"
          >
            <div slot="activator" class="beez-bold text-truncate">
              {{ task.approvalHeader.defaultValue.dimensionList[0].caption }}
            </div>
            <div slot="activator" class="text-truncate">
              {{ task.approvalHeader.defaultValue.dimensionList[0].value }}
            </div>
          </div>
        </v-flex>
        <v-flex>
          <div
            class="mt-2"
            style="font-size: 1.0em;"
            align="left"
            v-if="task.approvalHeader.defaultValue.dimensionList.length > 1"
          >
            <div slot="activator" class="beez-bold text-truncate">
              {{ task.approvalHeader.defaultValue.dimensionList[1].caption }}
            </div>
            <div slot="activator" class="text-truncate">
              {{ task.approvalHeader.defaultValue.dimensionList[1].value }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      sm12
      md4
      v-if="
        task.approvalHeader &&
          task.approvalHeader.defaultValue &&
          task.approvalHeader.defaultValue.dimensionList &&
          task.approvalHeader.defaultValue.dimensionList.length > 2
      "
    >
      <v-layout column>
        <v-flex>
          <div
            style="font-size: 1.0em;"
            align="left"
            v-if="task.approvalHeader.defaultValue.dimensionList.length > 2"
          >
            <div slot="activator" class="beez-bold text-truncate">
              {{ task.approvalHeader.defaultValue.dimensionList[2].caption }}
            </div>
            <div slot="activator" class="text-truncate">
              {{ task.approvalHeader.defaultValue.dimensionList[2].value }}
            </div>
          </div>
        </v-flex>
        <v-flex>
          <div
            class="mt-2"
            style="font-size: 1.0em;"
            align="left"
            v-if="task.approvalHeader.defaultValue.dimensionList.length > 3"
          >
            <div slot="activator" class="beez-bold text-truncate">
              {{ task.approvalHeader.defaultValue.dimensionList[3].caption }}
            </div>
            <div slot="activator" class="text-truncate">
              {{ task.approvalHeader.defaultValue.dimensionList[3].value }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      sm12
      md4
      v-if="
        task.approvalHeader &&
          task.approvalHeader.defaultValue &&
          task.approvalHeader.defaultValue.metricList &&
          task.approvalHeader.defaultValue.metricList.length > 0
      "
    >
      <div style="font-size: 1.0em;" class="text-xs-right">
        <div slot="activator" class="beez-bold text-truncate">
          {{ task.approvalHeader.defaultValue.metricList[0].caption }}
        </div>
        <div>
          <div slot="activator" class="beez-bold text-truncate">
            <span style="font-size: 0.8em">{{
              task.approvalHeader.defaultValue.metricList[0].unit
            }}</span>
            <span
              style="font-size: 1.2em; font-weight: 500"
              class="text-xs-right"
              >{{
                numberFormat(
                  task.approvalHeader.defaultValue.metricList[0].value
                )
              }}</span
            >
          </div>
        </div>
      </div>
      <div
        style="font-size: 1.0em;"
        class="mt-2 text-xs-right"
        v-if="
          task.approvalHeader &&
            task.approvalHeader.defaultValue &&
            task.approvalHeader.defaultValue.metricList &&
            task.approvalHeader.defaultValue.metricList.length > 1
        "
      >
        <div slot="activator" class="beez-bold text-truncate">
          {{ task.approvalHeader.defaultValue.metricList[1].caption }}
        </div>
        <div>
          <div slot="activator" class="beez-bold text-truncate">
            <span style="font-size: 0.8em">{{
              task.approvalHeader.defaultValue.metricList[1].unit
            }}</span>
            <span
              style="font-size: 1.2em; font-weight: 500"
              class="text-xs-right"
              >{{
                numberFormat(
                  task.approvalHeader.defaultValue.metricList[1].value
                )
              }}</span
            >
          </div>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: 'TaskDimensionsAndMetrics',
  props: {
    task: {}
  },
  methods: {
    numberFormat(param) {
      return parseFloat(param).toLocaleString()
    }
  }
}
</script>
